import api from "../utils/api";
import { isGuid } from "../utils/string";

const BASE_URL = "/accounts/trust-ledgers";

export const clientActivity = ({
  clientUuid,
  page = 0,
  size = 50,
  order = "entryDate",
  direction = "DESC",
} = {}) => async () => {
  try {
    if (!isGuid(clientUuid)) return { items: [], count: 0, success: false };
    const res = await api.get(`${BASE_URL}/client/${clientUuid}/activity/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}`);
    return res.data;
  } catch (err) {
    return { success: false, items: [], count: 0, error: err?.response?.data?.error || err };
  }
};

export const clientSummary = ({ clientUuid } = {}) => async () => {
  try {
    if (!isGuid(clientUuid)) return { success: false };
    const res = await api.get(`${BASE_URL}/client/${clientUuid}/summary`);
    return res.data;
  } catch (err) {
    return { success: false, error: err?.response?.data?.error || err };
  }
};

export const clearClientLines = ({
  clientUuid,
  lineUuids = [],
  cleared = true,
  clearedByUuid = null,
} = {}) => async () => {
  try {
    if (!isGuid(clientUuid)) return { success: false };
    const res = await api.post(`${BASE_URL}/client/${clientUuid}/clear`, {
      lineUuids,
      cleared,
      clearedByUuid,
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err?.response?.data?.error || err };
  }
};
